'use client';

import { useEffect, useState } from 'react';
import { EpLoading } from '../EpLoading';

export default function ClientOnly({ children }: { children: React.ReactNode }) {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return <EpLoading loadingId="client-mount" isVisible={true} />;
  }

  return <>{children}</>;
}